import ScopedAdminPage from "../components/ScopedAdminPage.jsx";
import {
    ClearLocalDataSection,
    PasswordSection,
} from "./SettingsPage.jsx";

export default function AccountPage({ viewDef }) {
    return (
        <ScopedAdminPage
            title={viewDef?.label ?? "User Settings"}
            description="Manage your sign-in and locally stored browser data."
        >
            <PasswordSection />
            <ClearLocalDataSection />
        </ScopedAdminPage>
    );
}
